module.exports = __webpack_public_path__ + "img/weight_orange.bc44ae47.svg";